/* Page mot de passe : le meme bureau que la boutique, en plus simple.
   Pas de sequence de demarrage ici — quelqu'un qui vient saisir un code ne
   doit pas patienter devant un BIOS. */
(function(){
  "use strict";
  var DATA = {};
  try { DATA = JSON.parse(document.getElementById('lock-data').textContent); } catch(e){}
  var APP = document.getElementById('app');
  var AUDIO = {};
  function play(url){
    if(!url) return;
    try {
      var a = AUDIO[url] || (AUDIO[url] = new Audio(url));
      a.currentTime = 0;
      var p = a.play(); if(p && p.catch) p.catch(function(){});
    } catch(e){}
  }
  var logo = document.getElementById('landLogo');
  if(logo && DATA.logo) logo.src = DATA.logo;

  var LWINS = [
    {id:'lwLogo',  w:322, label:'LOGO.BMP'},
    {id:'lwCount', w:352, label:'COMPTE A REBOURS'},
    {id:'lwMail',  w:296, label:'NEWSLETTER.EXE'},
    {id:'lwCode',  w:296, label:'ACCES.EXE'}
  ];
  var lz = 10;

  function focusWin(el){
    APP.querySelectorAll('.lwin').forEach(function(w){ w.classList.add('inactive'); });
    el.classList.remove('inactive');
    el.style.zIndex = ++lz;
  }
  function drag(el, handle){
    var on = false, sx = 0, sy = 0, ox = 0, oy = 0;
    handle.addEventListener('mousedown', function(e){
      if(e.target.closest('.tbtns')) return;
      if(window.innerWidth <= 760) return;
      on = true; sx = e.clientX; sy = e.clientY; ox = el.offsetLeft; oy = el.offsetTop;
      el.dataset.moved = '1';
      focusWin(el);
      e.preventDefault();
    });
    document.addEventListener('mousemove', function(e){
      if(!on) return;
      el.style.left = Math.max(-el.offsetWidth + 90,
                      Math.min(ox + e.clientX - sx, window.innerWidth - 80)) + 'px';
      el.style.top  = Math.max(0,
                      Math.min(oy + e.clientY - sy, window.innerHeight - 60)) + 'px';
    });
    document.addEventListener('mouseup', function(){ on = false; });
  }
  function place(){
    if(window.innerWidth <= 760) return;
    var W = window.innerWidth, H = window.innerHeight, cx = W / 2;
    var top = Math.max(24, Math.min(H * 0.13, H - 400));
    var pos = {
      lwLogo:  [cx - 352, top],
      lwCount: [cx + 6,   top],
      lwMail:  [cx - 352, top + 152],
      lwCode:  [cx + 6,   top + 172]
    };
    LWINS.forEach(function(w){
      var el = document.getElementById(w.id);
      if(!el || el.dataset.moved) return;
      el.style.width = w.w + 'px';
      el.style.left = Math.round(Math.max(8, Math.min(pos[w.id][0], W - w.w - 8))) + 'px';
      el.style.top  = Math.round(pos[w.id][1]) + 'px';
    });
  }
  function buildBar(){
    var bar = document.getElementById('lwTasks');
    if(!bar) return;
    LWINS.forEach(function(w){
      var el = document.getElementById(w.id);
      if(!el) return;
      var btn = document.createElement('div');
      btn.className = 'task on';
      btn.textContent = w.label;
      function show(){ el.style.display = 'flex'; btn.classList.add('on'); focusWin(el); }
      function hide(){ el.style.display = 'none'; btn.classList.remove('on'); play(DATA.sndMin); }
      btn.addEventListener('click', function(){
        if(el.style.display === 'none') show(); else hide();
      });
      el.querySelector('.lw-close').addEventListener('click', hide);
      el.addEventListener('mousedown', function(){ focusWin(el); });
      drag(el, el.querySelector('.titlebar'));
      bar.appendChild(btn);
    });
  }
  function countdown(){
    var target = (DATA.dropAt || 0) * 1000;
    var D = document.getElementById('cdD'), H = document.getElementById('cdH'),
        M = document.getElementById('cdM'), S = document.getElementById('cdS');
    function pad(n){ return (n < 10 ? '0' : '') + n; }
    function tick(){
      if(!target){ D.textContent = H.textContent = M.textContent = S.textContent = '--'; return; }
      var left = target - Date.now();
      if(left <= 0){
        /* La boutique n'ouvre pas d'elle-meme : la protection se retire dans
           l'admin. On se contente d'afficher zero. */
        D.textContent = H.textContent = M.textContent = S.textContent = '00';
        return;
      }
      var s = Math.floor(left / 1000);
      D.textContent = pad(Math.floor(s / 86400));
      H.textContent = pad(Math.floor(s / 3600) % 24);
      M.textContent = pad(Math.floor(s / 60) % 60);
      S.textContent = pad(s % 60);
    }
    tick();
    setInterval(tick, 1000);
  }

  buildBar();
  place();
  countdown();
  window.addEventListener('resize', place);
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(place);
  /* l'objet `form` n'existe qu'a l'interieur d'un bloc {% form %} : on lit
     donc l'erreur dans le DOM plutot que dans le JSON. */
  if(document.querySelector('.lock-err')){
    play(DATA.sndError);
    var f = document.getElementById('lockPass');
    if(f) f.focus();
  }

  /* le bandeau de consentement se deplace aussi, par sa barre de titre */
  function bindBanner(){
    var b = document.getElementById('shopify-pc__banner');
    if(!b || b.dataset.dragBound || window.innerWidth <= 760) return;
    b.dataset.dragBound = '1';
    var on = false, sx = 0, sy = 0, ox = 0, oy = 0;
    b.addEventListener('mousedown', function(e){
      if(e.target.closest('button, a, input, label')) return;
      var r = b.getBoundingClientRect();
      if(e.clientY - r.top > 22) return;
      on = true; sx = e.clientX; sy = e.clientY; ox = r.left; oy = r.top;
      b.style.setProperty('transform', 'none', 'important');
      b.style.setProperty('bottom', 'auto', 'important');
      b.style.setProperty('left', r.left + 'px', 'important');
      b.style.setProperty('top', r.top + 'px', 'important');
      e.preventDefault();
    });
    document.addEventListener('mousemove', function(e){
      if(!on) return;
      var w = b.offsetWidth;
      b.style.setProperty('left', Math.max(-w + 90,
        Math.min(ox + e.clientX - sx, window.innerWidth - 80)) + 'px', 'important');
      b.style.setProperty('top', Math.max(0,
        Math.min(oy + e.clientY - sy, window.innerHeight - 40)) + 'px', 'important');
    });
    document.addEventListener('mouseup', function(){ on = false; });
  }
  bindBanner();
  if(window.MutationObserver) new MutationObserver(bindBanner).observe(document.body, {childList:true});
})();
